import { render, staticRenderFns } from "./AllGateway.vue?vue&type=template&id=1a7960e6&"
import script from "./AllGateway.vue?vue&type=script&lang=ts&"
export * from "./AllGateway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports